<div class="d-flex flex-column gap-3" data-testid="refund-table-panel">
  <div class="d-flex flex-column gap-1">
    <h3 class="av-section-title m-0">{{ 'backoffice.billing.refunds.title' | translate }}</h3>
    <p class="av-meta m-0" data-testid="refund-cancellation-note">{{ 'backoffice.billing.refunds.not_from_cancellation' | translate }}</p>
  </div>

  @switch (facade.refundsState()) {
    @case ('restricted') {
      <av-empty-state
        icon="lock"
        [title]="'backoffice.billing.refunds.restricted_title' | translate"
        [message]="'backoffice.billing.documents.money_out_restricted' | translate"
      ></av-empty-state>
    }
    @case ('error') {
      <av-empty-state
        icon="error_outline"
        [title]="'backoffice.billing.refunds.error_title' | translate"
        [message]="'backoffice.billing.refunds.error_message' | translate"
      ></av-empty-state>
    }
    @case ('ready') {
      @if (isEmpty()) {
        <av-empty-state
          icon="undo"
          [title]="'backoffice.billing.refunds.empty_title' | translate"
          [message]="'backoffice.billing.refunds.empty_message' | translate"
        ></av-empty-state>
      } @else {
        <div class="table-scroll">
          <table class="av-table w-100" data-testid="refund-table">
            <thead>
              <tr>
                <th scope="col">{{ 'backoffice.billing.refunds.table.refund' | translate }}</th>
                <th scope="col">{{ 'backoffice.billing.refunds.table.status' | translate }}</th>
                <th scope="col" class="text-end">{{ 'backoffice.billing.refunds.table.amount' | translate }}</th>
                <th scope="col">{{ 'backoffice.billing.refunds.table.reason' | translate }}</th>
                <th scope="col">{{ 'backoffice.billing.refunds.table.created' | translate }}</th>
              </tr>
            </thead>

            <tbody>
              @for (refund of facade.refunds(); track refund.id) {
                <tr>
                  <td class="av-source">{{ refund.stripe_refund_id || unresolved }}</td>

                  <td>
                    <av-status-chip
                      [label]="refund.statusLabelKey | translate"
                      [tone]="refund.statusTone"
                    ></av-status-chip>
                  </td>

                  <td class="text-end">
                    {{ refund.amount | number: '1.2-2' }} {{ refund.currency || '' }}
                  </td>

                  <td class="cell-muted">
                    {{ reasonLabel(refund.reason) | translate }}
                  </td>

                  <td class="cell-muted">
                    {{ refund.created_at ? (refund.created_at | date: dateTimeFormat) : unresolved }}
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>

        <av-paginator
          [page]="facade.refundPage()"
          [pageSize]="facade.pageSize()"
          [total]="facade.refundTotal()"
          (pageChange)="goToPage($event)"
          (pageSizeChange)="changePageSize($event)"
        ></av-paginator>
      }
    }
    @default {
      <av-empty-state
        icon="hourglass_empty"
        [title]="'backoffice.billing.refunds.loading_title' | translate"
        [message]="'backoffice.billing.refunds.loading_message' | translate"
      ></av-empty-state>
    }
  }
</div>
